import axios from "axios";
import jwtDecode from "jwt-decode";
const API_URL = process.env.REACT_APP_URL_API;
//Partie config mulesoft
const API_URL_MULE = process.env.REACT_APP_URL_API_MULE;
const AUTHORIZATION_USERNAME = process.env.REACT_APP_URL_API_MULE_USERNAME;
const AUTHORIZATION_PASSWORD = process.env.REACT_APP_URL_API_MULE_PASSWORD;
const authToken = btoa(`${AUTHORIZATION_USERNAME}:${AUTHORIZATION_PASSWORD}`);
class AuthService {
  login(username, password) {
    var path="login_check";
    var uri = API_URL;
    if(process.env.REACT_APP_MULE==="1") {
      axios.defaults.headers.common['Authorization'] = `Basic ${authToken}`;
      path = "login";
      uri = API_URL_MULE;
    }
    return axios
      .post(uri + path, {
        username,
        password
      }, { mode: 'cors', credentials: 'include' })
      .then(response => {
        if (response.data.token) {
          const token = response.data.token;
          let user = [];
          user = jwtDecode(token);
          user['useremail'] = response.data.email;
          user['userid'] =  response.data.user_id;
          user['role'] = response.data.roles;
          user['service'] = response.data.service;
          localStorage.setItem("user", JSON.stringify(user));
          localStorage.setItem("token", token);
        }

        return response.data;
      });
  }


  logout() {
    localStorage.removeItem("user");
    window.location.replace("/login");
  }


  getCurrentUser() {
    return JSON.parse(localStorage.getItem('user'));
  }
}

export default new AuthService();
